import React, {Component} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {withStyles, Fab} from '@material-ui/core'
import Delete from '@material-ui/icons/Delete'
import CameraAlt from '@material-ui/icons/CameraAlt'

import {FormElement, SubmitButton, ArrowToolTip} from '../../../components/components'

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        paddingBottom: '2em',
        paddingTop: '3em',
        paddingLeft: '10em',
        paddingRight: '10em'
    },

    img: {
        height: '100%',
        width: '100%',
        marginBottom: '1em'
    },

    screenshotBorder: {
        border: '1px solid rgba(0, 0, 0, 0.2)',
    },

    imgIcon: {
        height: '100px',
        width: '100px',
        border: '0px',
        alignSelf: 'center'
    },

    imgIconLarge: {
        height: '25%',
        width: '25%',
        border: '0px',
        alignSelf: 'center'
    },

    imgDesc: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
    },

    submitButton: {
        width: 'auto',
        marginTop: '1em',
        alignSelf: 'center'
    },

    deleteFab: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    fabIcon: {
        position: 'relative',
        color: '#fff',
        marginLeft: '0.5em',
        top: '-45px'
    },

    offSetIcon: {
        top: '-2.5em',
        right: '-2em'
    }
}

class Screenshot extends Component {
    state = {
        isDisabled: false
    }

    getImagePreview = (file, elementRef) => {
        if (!elementRef) return

        if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml') {
            // eslint-disable-next-line no-undef
            const reader = new FileReader()
            reader.onload = event => elementRef.src = event.target.result
            reader.readAsDataURL(file)
        }
    }

    onValidationChangeDetected = () => {
        const isDisabled = Object.keys(this.formFieldsInputs).find(key => {
            return !this.formFieldsInputs[key].state.isValid
        }) !== undefined
        if (this.props.hasCaption) {
            if (this.props.onValidationChangeDetected) this.props.onValidationChangeDetected(!isDisabled)
            this.setState({isDisabled})
        }
    }

    formFields = [
        {label: 'Caption 1', name: 'caption1', minLength: 3, maxLength: 100, type: 'text', required: true},
        {label: 'Caption 2', name: 'caption2', minLength: 3, maxLength: 100, type: 'text', required: false}
    ]

    formFieldsInputs = {}
    componentDidMount() {
        const { defaultCaption1, defaultCaption2, hasCaption } = this.props

        if (hasCaption) {
            this.formFieldsInputs.caption1.setValue(defaultCaption1 || '')
            this.formFieldsInputs.caption2.setValue(defaultCaption2 || '')

            this.setState({loaded: true});
        }
    }

    render() {
        const { classes: styles, file, hasCaption, previewSize, defaultImg, save, onDelete, onClick } = this.props

        if (!file && defaultImg) {
            return (
                <div className={styles.container}>
                    <div className={classNames(styles.img, previewSize === 'icon' && styles.imgIcon, previewSize === 'iconLarge' && styles.imgIconLarge)}>
                        <img className={previewSize === 'default' && styles.screenshotBorder} style={{width: '100%', height: '100%'}} alt={'defaultImg'} src={defaultImg} />
                        <div className={styles.deleteFab}>
                            {onClick &&
                            <ArrowToolTip placement={'bottom'} title={'Change'}>
                                <Fab className={classNames(styles.fabIcon, !onDelete && styles.offSetIcon)} color={'primary'} onClick={onClick}>
                                    <CameraAlt />
                                </Fab>
                            </ArrowToolTip>
                            }
                            {onDelete &&
                            <ArrowToolTip placement={'right'} title={'Delete'}>
                                <Fab className={styles.fabIcon} color={'secondary'} onClick={onDelete}>
                                    <Delete />
                                </Fab>
                            </ArrowToolTip>
                            }
                        </div>
                    </div>
                    {hasCaption && this.formFields.map((props, index) => (
                        <FormElement key={index} {...props} innerRef={ref => (this.formFieldsInputs[props.name] = ref || this.formFieldsInputs[props.name])} onValidationChangeDetected={this.onValidationChangeDetected} />
                    ))}
                    {save && <SubmitButton className={styles.submitButton} isDisabled={this.state.isDisabled} onClick={save}>Save Changes</SubmitButton>}
                </div>
            )
        }

        return (
            <div className={styles.container}>
                <div className={classNames(styles.img, previewSize === 'icon' && styles.imgIcon, previewSize === 'iconLarge' && styles.imgIconLarge)}>
                    <img className={previewSize === 'default' && styles.screenshotBorder} style={{width: '100%', height: '100%'}} alt={file.filename} ref={ref => this.getImagePreview(file, ref)} />
                    <div className={styles.deleteFab}>
                        {onClick &&
                        <ArrowToolTip placement={'bottom'} title={'Change'}>
                            <Fab className={classNames(styles.fabIcon, !onDelete && styles.offSetIcon)} color={'primary'} onClick={onClick}>
                                <CameraAlt />
                            </Fab>
                        </ArrowToolTip>
                        }
                        {onDelete &&
                        <ArrowToolTip placement={'right'} title={'Delete'}>
                            <Fab className={styles.fabIcon} color={'secondary'} onClick={onDelete}>
                                <Delete />
                            </Fab>
                        </ArrowToolTip>
                        }
                    </div>
                </div>
                <div className={styles.imgDesc}>
                    {hasCaption && this.formFields.map((props, index) => (
                        <FormElement key={index} {...props} innerRef={ref => (this.formFieldsInputs[props.name] = ref || this.formFieldsInputs[props.name])} onValidationChangeDetected={this.onValidationChangeDetected} />
                    ))}
                    {save && <SubmitButton className={styles.submitButton} isDisabled={this.state.isDisabled} onClick={save}>Save Changes</SubmitButton>}
                </div>
            </div>
        )
    }
}

Screenshot.propTypes = {
    classes: PropTypes.object.isRequired,
    file: PropTypes.any,
    hasCaption: PropTypes.bool,
    previewSize: PropTypes.string,
    defaultImg: PropTypes.any,
    defaultCaption1: PropTypes.string,
    defaultCaption2: PropTypes.string,
    save: PropTypes.func,
    onValidationChangeDetected: PropTypes.func,
    onClick: PropTypes.func
}

Screenshot.defaultProps = {
    previewSize: 'default'
}

export default withStyles(styles)(Screenshot);
